/* Section-safe media stories. No autoplay; opening and closing preserve keyboard focus. */
(() => {
  class ProductStories extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      const track = this.querySelector('[data-story-track]');
      if (!track) return;
      const cards = [...track.querySelectorAll('[data-story-card]')];
      const previous = this.querySelector('[data-story-prev]');
      const next = this.querySelector('[data-story-next]');
      const status = this.querySelector('[data-story-status]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const sync = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = track.scrollLeft < 2;
        if (next) next.disabled = track.scrollLeft >= maximum - 2;
        if (status) {
          const width = step() || 1;
          const first = Math.min(cards.length, Math.round(track.scrollLeft / width) + 1);
          const last = Math.min(cards.length, Math.ceil((track.scrollLeft + track.clientWidth) / width));
          status.textContent = first === last ? `${first} / ${cards.length}` : `${first}–${last} / ${cards.length}`;
        }
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: reduced.matches ? 'instant' : 'smooth' });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-story-prev]')) move(-1);
        if (event.target.closest('[data-story-next]')) move(1);
        const opener = event.target.closest('[data-story-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.storyOpen);
          if (dialog && this.contains(dialog) && dialog.showModal) {
            event.preventDefault();
            this.opener = opener;
            dialog.showModal();
          }
        }
        const dialog = event.target.closest('dialog');
        if (event.target.closest('[data-story-close]')) dialog?.close();
        if (dialog && event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      }, { signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, { signal });
      track.addEventListener('scroll', sync, { signal, passive: true });
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        this.opener?.focus({ preventScroll: true });
      }, { signal }));
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-story-card]');
        if (card) track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'instant' });
      }, { signal });
      this.resize = new ResizeObserver(sync);
      this.resize.observe(track);
      sync();
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.events?.abort();
      this.resize?.disconnect();
    }
  }
  if (!customElements.get('hgm-product-stories')) customElements.define('hgm-product-stories', ProductStories);
})();
